<template>
  <v-menu absolute class="logged-user-menu z-index" offset-y>
    <template v-slot:activator="{ on }">
      <v-list class="pa-0" color="primary">
        <v-list-item id="toolbar-menu" v-on="on">
          <v-avatar color="marca-0-l10" size="45">{{ $getLoggedUser().name && $getLoggedUser().name.charAt(0) }}</v-avatar>
          <span v-if="$vuetify.breakpoint.smAndUp" class="pl-2 user-name">{{ $getLoggedUser().name }}</span>
          <mf-icon color="branco" fill>keyboard_arrow_down</mf-icon>
        </v-list-item>
      </v-list>
    </template>
    <v-list>
      <v-list-item v-if="$getLoggedUser().admin" @click="redirect('/usuarios')">
        <v-list-item-title>Usuários</v-list-item-title>
      </v-list-item>
      <v-list-item id="logout" @click="logout">
        <v-list-item-title>Sair</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mapWaitingActions } from 'vue-wait'

import { formattedRedirectLogout } from '@/helpers/login'

export default {
  computed: {
    isAdmin() {
      return this.$getIsAdmin()
    },
  },
  methods: {
    ...mapWaitingActions({
      getUsuarios: 'users',
    }),
    redirect(path) {
      this.$router.push(path).catch(() => {})
    },
    logout() {
      const singleLoginURL = this.$microservicesUrls['mfLogin']
      const host = location.href.slice(0, location.href.indexOf('#'))
      const hash = window.localStorage.getItem('redirectAfterLogin') || ''

      this.$logout()
      window.location.href = formattedRedirectLogout(singleLoginURL, host, hash)
    },
  },
}
</script>
